/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-regarde': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M17.77 8.37c-.16-.19-3.94-4.56-8.77-4.56S.39 8.18.23 8.37a1 1 0 000 1.26c.16.19 3.94 4.56 8.77 4.56s8.61-4.37 8.77-4.56a1 1 0 000-1.26zm-7.29-1.93a.79.79 0 011 .45.8.8 0 01-.16 1.11.81.81 0 01-1-.46.79.79 0 01.16-1.1zM9 12.61C5.63 12.61 2.79 10 1.8 9a13.56 13.56 0 014.13-2.93 3.67 3.67 0 106.14 0A13.56 13.56 0 0116.2 9c-.99 1-3.83 3.61-7.2 3.61z"/>'
  }
})
